import { Flex, Text } from '@nula/core-ui';
import { useViewSearch } from './hooks/use-view-search';
import { CanvasEditor } from './canvas-editor';
import { SpaceLensToggle } from './space-lens-toggle';
import styles from './space-mount.module.css';

interface SpaceMountProps {
  entityId: string;
}

/**
 * Mount component for `kind='space'` entities.
 *
 * Routes by `?view`:
 *   - undefined / anything other than 'canvas'  →  List view (placeholder — not yet implemented)
 *   - 'canvas'                                  →  Canvas view via CanvasDocumentMount (docType='space')
 *
 * No init call is needed: handle_subscribe auto-creates the spaces row on first
 * WS connect; RoomManager::get_or_create_room treats NULL canvas_state as empty
 * bytes; first client write self-populates via the existing flush_room Space arm.
 */
export function SpaceMount({ entityId }: SpaceMountProps) {
  const { view } = useViewSearch();

  if (view === 'canvas') {
    return (
      <Flex vertical data-testid="space-root" className={styles.listView} gap="md">
        <SpaceLensToggle />
        <CanvasEditor entityId={entityId} entityKind="space" />
      </Flex>
    );
  }

  return (
    <Flex vertical data-testid="space-list-view" className={styles.listView} gap="md">
      <SpaceLensToggle />
      <Text type="secondary">Space list view</Text>
      <Text size="xs" type="secondary">
        Space list view is not yet implemented. This placeholder is rendered so
        canvas-side toggling can be tested independently.
      </Text>
    </Flex>
  );
}
